import { navigationData } from './navigation-data.js';

export interface NavigationItem {
  path: string;
  label: string;
  description: string;
  priority: number;
  changefreq: 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never';
  children?: NavigationItem[];
  isPrivate?: boolean;
  isAdmin?: boolean;
  keywords?: string[];
}

export const navigationConfig: NavigationItem[] = navigationData as NavigationItem[];

// Helper function to get all paths (including nested ones)
export const getAllPaths = (): NavigationItem[] => {
  const allPaths: NavigationItem[] = [];
  
  const extractPaths = (items: NavigationItem[]) => {
    items.forEach(item => {
      allPaths.push(item);
      if (item.children) {
        extractPaths(item.children);
      }
    });
  };
  
  extractPaths(navigationConfig);
  return allPaths;
};

// Helper function to get breadcrumb path for a given route
export const getBreadcrumbPath = (currentPath: string): NavigationItem[] => {
  const breadcrumbs: NavigationItem[] = [];
  
  const findPath = (items: NavigationItem[], targetPath: string, currentBreadcrumbs: NavigationItem[] = []): boolean => {
    for (const item of items) {
      const newBreadcrumbs = [...currentBreadcrumbs, item];
      
      if (item.path === targetPath) {
        breadcrumbs.push(...newBreadcrumbs);
        return true;
      }
      
      if (item.children && findPath(item.children, targetPath, newBreadcrumbs)) {
        return true;
      }
    }
    return false;
  };
  
  findPath(navigationConfig, currentPath);
  return breadcrumbs;
};

// Helper function to get sitemap data
export const getSitemapData = () => {
  return getAllPaths()
    .filter(item => !item.isPrivate && !item.isAdmin)
    .map(item => ({
      url: item.path,
      priority: item.priority,
      changefreq: item.changefreq,
      lastmod: new Date().toISOString().split('T')[0]
    }));
};
